import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-statuses-info',
  standalone: true,
  templateUrl: './statuses-info.component.html',
  styleUrl: './statuses-info.component.scss',
})
export class StatusesInfoComponent {
  data = null;
  protected readonly Object = Object;

  @Input() set text(value: string) {
    if (value) {
      this.data = JSON.parse(value);
    } else {
      this.data = { supervisor: false, patient: false, hha: false };
    }
  }
}
